/* eslint-disable @typescript-eslint/camelcase */
import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../../common/CCUtils"
import { PhaserUtils } from "../../../utils/PhaserUtils"

export enum EcigTourAssets {
    INTRO_SCENE = "TourINTRO_SCENE",
    ELIQUID = "TourELIQUID",
    ELIQUID_MOLECULES = "TourELIQUID_MOLECULES",
    ELIQUID_BACKGROUND = "TourELIQUID_BACKGROUND",
    ACETALDEHYDE = "TourACETALEHYDE",
    CADMIUM = "TourCADMIUM",
    LEAD = "TourLEAD",
    NICOTINE = "TourNICOTINE",
    PROPYLENE_GLYCOL = "TourPROPYLENE_GLYCOL",
    BUTTON = "TourBUTTON",

    ACETALEHYDE_SCENE = "TourACETALEHYDE_SCENE",
    CADMIUM_SCENE = "TourCADMIUM_SCENE",
    LEAD_SCENE = "TourLEAD_SCENE",
    NICOTINE_SCENE = "TourNICOTINE_SCENE",
    PROPYLENE_GLYCOL_SCENE = "TourPROPYLENE_GLYCOL_SCENE",

    ACETALEHYDE_NOTE = "TourACETALEHYDE_NOTE",
    CADMIUM_NOTE = "TourCADMIUM_NOTE",
    LEAD_NOTE = "TourLEAD_NOTE",
    NICOTINE_NOTE = "TourNICOTINE_NOTE",
    PROPYLENE_GLYCOL_NOTE = "TourPROPYLENE_GLYCOL_NOTE",

    // Audio enum values below here
    INTRO_AUDIO = "TourINTRO_AUDIO",
    EXIT_AUDIO = "TourEXIT_AUDIO",
    CLICK_MOLECULE = "TourCLICK_MOLECULE",
    ACETALDEHYDE_AUDIO = "TourAUDIO_3",
    CADMIUM_AUDIO = "TourAUDIO_4",
    PROPYLENE_GLYCOL_AUDIO = "TourPROPYLENE_GLYCOL_AUDIO",
    NICOTINE_AUDIO = "TourNICOTINE_AUDIO",
    LEAD_AUDIO = "TourLEAD_AUDIO",

    CLICK_LETS_REVIEW = "TourCLICK_LETS_REVIEW",
    BUZZ = "TourBUZZ",
    TRY_AGAIN = "TourTRY_AGAIN",
    THATS_CORRECT = "TourTHATS_CORRECT",
    GOOD_JOB = "TourGOOD_JOB",
    YOURE_RIGHT = "TourYOURE_RIGHT",

    NICOTINE_QUESTION = "TourNICOTINE_QUESTION",
    ANSWER_TRUE = "TourANSWER_TRUE",
    ANSWER_FALSE = "TourANSWER_FALSE",
    ACETALDEHYDE_QUESTION = "TourACETALDEHYDE_QUESTION",
    ACETALDEHYDE_ANSWER_1 = "TourACETALDEHYDE_ANSWER_1",
    ACETALDEHYDE_ANSWER_2 = "TourACETALDEHYDE_ANSWER_2",
    ACETALDEHYDE_ANSWER_3 = "TourACETALDEHYDE_ANSWER_3",
    ACETALDEHYDE_ANSWER_4 = "TourACETALDEHYDE_ANSWER_4",
    CADMIUM_QUESTION = "TourCADMIUM_QUESTION",
    CADMIUM_ANSWER_1 = "TourCADMIUM_ANSWER_1",
    CADMIUM_ANSWER_2 = "TourCADMIUM_ANSWER_2",
    CADMIUM_ANSWER_3 = "TourCADMIUM_ANSWER_3",
    CADMIUM_ANSWER_4 = "TourCADMIUM_ANSWER_4",
    PROPYLENE_GLYCOL_QUESTION = "TourPROPYLENE_GLYCOL_QUESTION",
    LEAD_QUESTION = "TourLEAD_QUESTION",
    LEAD_ANSWER_1 = "TourLEAD_ANSWER_1",
    LEAD_ANSWER_2 = "TourLEAD_ANSWER_2",
    LEAD_ANSWER_3 = "TourLEAD_ANSWER_3",
    LEAD_ANSWER_4 = "TourLEAD_ANSWER_4",
}

export enum EcigTourAudio {
    TRUE = "ecig-tour-review-true.mp3",
    FALSE = "ecig-tour-review-false.mp3",
    REVIEW_QUESTION_1 = "ecig-tour-review-question-1.mp3",

    REVIEW_QUESTION_2 = "ecig-tour-review-question-2.mp3",
    REVIEW_QUESTION_2a = "ecig-tour-review-question-2a.mp3",
    REVIEW_QUESTION_2b = "ecig-tour-review-question-2b.mp3",
    REVIEW_QUESTION_2c = "ecig-tour-review-question-2c.mp3",
    REVIEW_QUESTION_2d = "ecig-tour-review-question-2d.mp3",

    REVIEW_QUESTION_3 = "ecig-tour-review-question-3.mp3",
    REVIEW_QUESTION_3a = "ecig-tour-review-question-3a.mp3",
    REVIEW_QUESTION_3b = "ecig-tour-review-question-3b.mp3",
    REVIEW_QUESTION_3c = "ecig-tour-review-question-3c.mp3",
    REVIEW_QUESTION_3d = "ecig-tour-review-question-3d.mp3",

    REVIEW_QUESTION_4 = "ecig-tour-review-question-4.mp3",

    REVIEW_QUESTION_5 = "ecig-tour-review-question-5.mp3",
    REVIEW_QUESTION_5a = "ecig-tour-review-question-5a.mp3",
    REVIEW_QUESTION_5b = "ecig-tour-review-question-5b.mp3",
    REVIEW_QUESTION_5c = "ecig-tour-review-question-5c.mp3",
    REVIEW_QUESTION_5d = "ecig-tour-review-question-5d.mp3",

    REVIEW_QUESTION_6 = "ecig-tour-review-question-6.mp3",

    REVIEW_QUESTION_7 = "ecig-tour-review-question-7.mp3",
    REVIEW_QUESTION_7a = "ecig-tour-review-question-7a.mp3",
    REVIEW_QUESTION_7b = "ecig-tour-review-question-7b.mp3",
    REVIEW_QUESTION_7c = "ecig-tour-review-question-7c.mp3",
    REVIEW_QUESTION_7d = "ecig-tour-review-question-7d.mp3",

    REVIEW_QUESTION_8 = "ecig-tour-review-question-8.mp3",
    REVIEW_QUESTION_8a = "ecig-tour-review-question-8a.mp3",
    REVIEW_QUESTION_8b = "ecig-tour-review-question-8b.mp3",
    REVIEW_QUESTION_8c = "ecig-tour-review-question-8c.mp3",
    REVIEW_QUESTION_8d = "ecig-tour-review-question-8d.mp3",

    REVIEW_QUESTION_9 = "ecig-tour-review-question-9.mp3",
    REVIEW_QUESTION_9a = "ecig-tour-review-question-9a.mp3",
    REVIEW_QUESTION_9b = "ecig-tour-review-question-9b.mp3",
    REVIEW_QUESTION_9c = "ecig-tour-review-question-9c.mp3",
    REVIEW_QUESTION_9d = "ecig-tour-review-question-9d.mp3",

    REVIEW_QUESTION_10 = "ecig-tour-review-question-10.mp3",
    REVIEW_QUESTION_10a = "ecig-tour-review-question-10a.mp3",
    REVIEW_QUESTION_10b = "ecig-tour-review-question-10b.mp3",
    REVIEW_QUESTION_10c = "ecig-tour-review-question-10c.mp3",
    REVIEW_QUESTION_10d = "ecig-tour-review-question-10d.mp3",
}

export function loadAssets(game: Phaser.Game) {
    game.load.image(
        EcigTourAssets.INTRO_SCENE,
        CCUtils.asset("ecig-tour/e-cig-tour.png"),
    )
    game.load.image(
        EcigTourAssets.ELIQUID,
        CCUtils.asset("ecig-tour/eliquid.png"),
    )
    game.load.image(
        EcigTourAssets.ELIQUID_MOLECULES,
        CCUtils.asset("ecig-tour/e-liquid-w-molecules.png"),
    )
    game.load.image(
        EcigTourAssets.ELIQUID_BACKGROUND,
        CCUtils.asset("ecig-tour/e-liquid-bg.png"),
    )
    game.load.image(
        EcigTourAssets.ACETALDEHYDE,
        CCUtils.asset("ecig-tour/acetaldehyde-molecule.png"),
    )
    game.load.image(
        EcigTourAssets.CADMIUM,
        CCUtils.asset("ecig-tour/cadmium-molecule.png"),
    )
    game.load.image(
        EcigTourAssets.LEAD,
        CCUtils.asset("ecig-tour/lead-molecule.png"),
    )
    game.load.image(
        EcigTourAssets.NICOTINE,
        CCUtils.asset("ecig-tour/nicotine-molecule.png"),
    )
    game.load.image(
        EcigTourAssets.PROPYLENE_GLYCOL,
        CCUtils.asset("ecig-tour/propylene-glycol-molecule.png"),
    )
    game.load.image(
        EcigTourAssets.BUTTON,
        CCUtils.asset("ecig-tour/button.png"),
    )

    game.load.image(
        EcigTourAssets.ACETALEHYDE_SCENE,
        CCUtils.asset("ecig-tour/acetaldehyde-scene.png"),
    )
    game.load.image(
        EcigTourAssets.CADMIUM_SCENE,
        CCUtils.asset("ecig-tour/cadmium-scene.png"),
    )
    game.load.image(
        EcigTourAssets.LEAD_SCENE,
        CCUtils.asset("ecig-tour/lead-scene.png"),
    )
    game.load.image(
        EcigTourAssets.NICOTINE_SCENE,
        CCUtils.asset("ecig-tour/nicotine-scene.png"),
    )
    game.load.image(
        EcigTourAssets.PROPYLENE_GLYCOL_SCENE,
        CCUtils.asset("ecig-tour/propylene-glycol-scene.png"),
    )

    game.load.image(
        EcigTourAssets.ACETALEHYDE_NOTE,
        CCUtils.asset("ecig-tour/dr-note-acetaldehyde.png"),
    )
    game.load.image(
        EcigTourAssets.CADMIUM_NOTE,
        CCUtils.asset("ecig-tour/dr-note-cadmium.png"),
    )
    game.load.image(
        EcigTourAssets.LEAD_NOTE,
        CCUtils.asset("ecig-tour/dr-note-lead.png"),
    )
    game.load.image(
        EcigTourAssets.NICOTINE_NOTE,
        CCUtils.asset("ecig-tour/dr-note-nicotine.png"),
    )
    game.load.image(
        EcigTourAssets.PROPYLENE_GLYCOL_NOTE,
        CCUtils.asset("ecig-tour/dr-note-propylene-glycol.png"),
    )

    game.load.audio(
        EcigTourAssets.INTRO_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n1.mp3"),
    )
    game.load.audio(
        EcigTourAssets.EXIT_AUDIO,
        CCUtils.asset("ecig-tour/audio/exit.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CLICK_MOLECULE,
        CCUtils.asset("ecig-tour/audio/tour-n2.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n3.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n4.mp3"),
    )
    game.load.audio(
        EcigTourAssets.PROPYLENE_GLYCOL_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n5.mp3"),
    )
    game.load.audio(
        EcigTourAssets.NICOTINE_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n6.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_AUDIO,
        CCUtils.asset("ecig-tour/audio/tour-n7.mp3"),
    )

    game.load.audio(
        EcigTourAssets.CLICK_LETS_REVIEW,
        CCUtils.asset("ecig-tour/audio/click-lets-review.mp3"),
    )
    game.load.audio(
        EcigTourAssets.BUZZ,
        CCUtils.asset("ecig-tour/audio/short-buzz.wav"),
    )
    game.load.audio(
        EcigTourAssets.TRY_AGAIN,
        CCUtils.asset("ecig-tour/audio/tour-n-tryagain.mp3"),
    )
    game.load.audio(
        EcigTourAssets.THATS_CORRECT,
        CCUtils.asset("ecig-tour/audio/tour-n-thatscorrect.mp3"),
    )
    game.load.audio(
        EcigTourAssets.GOOD_JOB,
        CCUtils.asset("ecig-tour/audio/tour-n-goodjob.mp3"),
    )
    game.load.audio(
        EcigTourAssets.YOURE_RIGHT,
        CCUtils.asset("ecig-tour/audio/tour-n-youreright.mp3"),
    )

    game.load.audio(
        EcigTourAssets.NICOTINE_QUESTION,
        CCUtils.asset("ecig-tour/audio/nicotine-question.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ANSWER_TRUE,
        CCUtils.asset("ecig-tour/audio/true-answer.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ANSWER_FALSE,
        CCUtils.asset("ecig-tour/audio/false-answer.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_QUESTION,
        CCUtils.asset("ecig-tour/audio/acetaldehyde-question.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_ANSWER_1,
        CCUtils.asset("ecig-tour/audio/acetaldehyde-answer1.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_ANSWER_2,
        CCUtils.asset("ecig-tour/audio/acetaldehyde-answer2.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_ANSWER_3,
        CCUtils.asset("ecig-tour/audio/acetaldehyde-answer3.mp3"),
    )
    game.load.audio(
        EcigTourAssets.ACETALDEHYDE_ANSWER_4,
        CCUtils.asset("ecig-tour/audio/acetaldehyde-answer4.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_QUESTION,
        CCUtils.asset("ecig-tour/audio/cadmium-question.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_ANSWER_1,
        CCUtils.asset("ecig-tour/audio/cadmium-answer1.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_ANSWER_2,
        CCUtils.asset("ecig-tour/audio/cadmium-answer2.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_ANSWER_3,
        CCUtils.asset("ecig-tour/audio/cadmium-answer3.mp3"),
    )
    game.load.audio(
        EcigTourAssets.CADMIUM_ANSWER_4,
        CCUtils.asset("ecig-tour/audio/cadmium-answer4.mp3"),
    )
    game.load.audio(
        EcigTourAssets.PROPYLENE_GLYCOL_QUESTION,
        CCUtils.asset("ecig-tour/audio/propylene-glycol-question.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_QUESTION,
        CCUtils.asset("ecig-tour/audio/lead-question.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_ANSWER_1,
        CCUtils.asset("ecig-tour/audio/lead-answer1.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_ANSWER_2,
        CCUtils.asset("ecig-tour/audio/lead-answer2.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_ANSWER_3,
        CCUtils.asset("ecig-tour/audio/lead-answer3.mp3"),
    )
    game.load.audio(
        EcigTourAssets.LEAD_ANSWER_4,
        CCUtils.asset("ecig-tour/audio/lead-answer4.mp3"),
    )

    const load = PhaserUtils.makeLoader(game, "ecig-tour")
    load.autoLoad({ audioEnum: EcigTourAudio })
}
